import { LARGE_SCREEN_BREAKPOINT, MEDIUM_LARGE_SCREEN_BREAKPOINT, MEDIUM_SCREEN_BREAKPOINT, SMALL_SCREEN_BREAKPOINT, } from './constants';
export const isMediumScreen = () => {
    return window.innerWidth >= MEDIUM_SCREEN_BREAKPOINT;
};
export const isSmallScreen = () => {
    return window.innerWidth < MEDIUM_SCREEN_BREAKPOINT;
};
export const isExtraSmallScreen = () => {
    return window.innerWidth < SMALL_SCREEN_BREAKPOINT;
};
export const isLargeScreen = () => {
    return window.innerWidth >= LARGE_SCREEN_BREAKPOINT;
};
export const isMediumLargeScreen = () => {
    return window.innerWidth >= MEDIUM_LARGE_SCREEN_BREAKPOINT;
};
export const isSmallLargeScreen = () => {
    return window.innerWidth < MEDIUM_LARGE_SCREEN_BREAKPOINT;
};
